import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Carousel from "nuka-carousel";
import { getCasePinURL } from "components/Shared/Map";
import { MSpinner, MDialog, MField } from "components/Shared";
import MGrid, { ACTION_CONFIGURE, ACTION_MAP, ACTION_DOWNLOAD } from "components/Shared/MGrid.tsx";
import { DATA_TYPE_DAYS_ELAPSED, DATA_TYPE_DATE_TIME, DATA_TYPE_DATE, DATA_TYPE_STRING } from "typeConstants/dataTypes";
import MSectionCollection, { MSECTION_MODE_TAB } from "components/Shared/MSectionCollection";
import { QuickList, QuickListEdit, QuickListGroup } from "components/Homeowner/Dashboard";
import { ASSIGNMENT_MODE_APPRAISAL, ASSIGNMENT_MODE_INSURANCE } from "components/Assignment";
import MSplitter from "components/Shared/MSplitter.tsx";
import { CaseHeader } from "components/Homeowner/CaseForms";
import MCaseView from "containers/Homeowner/MCaseView";
import {
  UnderwriterAssign, UnderwriterUnassign, CaseAssignment,
  QualityAssuranceAssign, IncidentAssign, QualityAssuranceUnassign,
  MoveToScheduling, MoveToMap,
} from "components/QuickLists/Dialogs";
import BrokerCaseHeader from "components/Broker/BrokerCaseHeader";
import { getNextCase } from "requests/underwriter";
import { isCustomer } from "components/Shared/Functions";
import { quickListTemplateCode, nonCaseBasedTemplateCodes } from "typeConstants/quickListTemplateCode";
import CaseHeaderV2 from "components/Homeowner/CaseForms/CaseHeaderV2/CaseHeaderV2";
import { DialogContext } from "components/Shared/DialogProvider.tsx";
import { updateETA, TYPE_CODE_APPRAISER_DELIVERY } from "requests/caseETA";
import { addCaseNote } from "requests/homeowner/caseforms";
import { PrimaryStatus } from "typeConstants/caseStatusCodes";
import { getEnabledFeatures } from "requests/customer";
import NoteInputField, { NOTE_EXTERNAL } from "components/Shared/NoteInputField";
import moment from "moment";
import { runBulkAutoQAProcess } from "requests/autoQA";
import { getQuickListShareGuidsByGroupName } from "requests/quickList";
import WebConfig from "middlewares/WebConfig";
import HiringNeed from "components/HiringNeed";
import { CASE_NOTE_TYPE_GENERAL } from "typeConstants/caseNoteTypes";
import { filterTypes } from "typeConstants/quicklistFilters";
import FieldRepProfileV2 from "components/Homeowner/FieldReps/FieldRepProfileV2";
import SummaryAuditView from 'components/QualityAssurance/Views/SummaryAuditView';
import AppraiserProfilePanel from 'containers/Appraiser/ProfilePanel';
import { dateToStringYy } from "components/Shared/Formatters";
import { putOnHold } from "requests/onHold";
import CaseDuplicateAsDialog from "components/Homeowner/CaseForms/Actions/CaseDuplicateAsDialog.tsx";
import QuickFilterSection from "./QuickFilterSection.tsx";
import AgentQuickListProfile from "components/QualityAssurance/Agent/AgentQuickListProfile.tsx";
import {UNDERWRITER_ASSIGN} from "typeConstants/rights";

class StaticQuickLists extends Component {
  static contextType = DialogContext;
  constructor(props) {
    super(props);

    this.expandCollapseClicked = this.expandCollapseClicked.bind(this);
    this.openInPanel = this.openInPanel.bind(this);
    this.openWithRouter = this.openWithRouter.bind(this);
    this.getMapPinForRow = this.getMapPinForRow.bind(this);
    this.getMapToolTipForRow = this.getMapToolTipForRow.bind(this);
    this.fixGridHeight = this.fixGridHeight.bind(this);
    this.generateList = this.generateList.bind(this);
    this.getQuickFiltersForServer = this.getQuickFiltersForServer.bind(this);
    this.onQuickListMenuClick = this.onQuickListMenuClick.bind(this);
    this.onTabChange = this.onTabChange.bind(this);
    this.onAddClick = this.onAddClick.bind(this);
    this.onGroupClick = this.onGroupClick.bind(this);
    this.onApplyClick = this.onApplyClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.renderEditor = this.renderEditor.bind(this);
    this.renderGroup = this.renderGroup.bind(this);
    this.onApplyGroupClick = this.onApplyGroupClick.bind(this);
    this.onAssignmentClick = this.onAssignmentClick.bind(this);
    this.loadAssignmentToolWithCases = this.loadAssignmentToolWithCases.bind(this);
    this.getGridActions = this.getGridActions.bind(this);
    this.navigateToCase = this.navigateToCase.bind(this);
    this.onUnderwriterAssignClick = this.onUnderwriterAssignClick.bind(this);
    this.hideUnderwriterAssign = this.hideUnderwriterAssign.bind(this);
    this.onUnderwriterUnassignClick = this.onUnderwriterUnassignClick.bind(this);
    this.hideUnderwriterUnassign = this.hideUnderwriterUnassign.bind(this);
    this.getSelectedControlNumbers = this.getSelectedControlNumbers.bind(this);
    this.reviewerQuicklistSelected = this.isSelectableQuicklist.bind(this);
    this.hideAssignmentDialog = this.hideAssignmentDialog.bind(this);
    this.getTabBarActions = this.getTabBarActions.bind(this);
    this.getPushToPaneTabs = this.getPushToPaneTabs.bind(this);
    this.navigateToHiringNeed = this.navigateToHiringNeed.bind(this);
    this.hideQaAssignDialog = this.hideQaAssignDialog.bind(this);
    this.onQaAssignClick = this.onQaAssignClick.bind(this);
    this.getSelectedQaCases = this.getSelectedQaCases.bind(this);
    this.addMultipleLastNote = this.addMultipleLastNote.bind(this);
    this.addMultipleAppraiserEta = this.addMultipleAppraiserEta.bind(this);
    this.showConfirmAddMultipleDialog = this.showConfirmAddMultipleDialog.bind(this);
    this.confirmAddMultiple = this.confirmAddMultiple.bind(this);
    this.setMultipleLastNote = this.setMultipleLastNote.bind(this);
    this.onIncidentAssignClick = this.onIncidentAssignClick.bind(this);
    this.hideIncidentAssignDialog = this.hideIncidentAssignDialog.bind(this);
    this.onNoteSave = this.onNoteSave.bind(this);
    this.onNoteCancel = this.onNoteCancel.bind(this);
    this.onAddBulkAutoQA = this.onAddBulkAutoQA.bind(this);
    this.bulkPutCaseOnHold = this.bulkPutCaseOnHold.bind(this);
    this.onShareGroupClick = this.onShareGroupClick.bind(this);
    this.getCaseView = this.getCaseView.bind(this);
    this.hideQaUnassignDialog = this.hideQaUnassignDialog.bind(this);
    this.onQaUnassignClick = this.onQaUnassignClick.bind(this);
    this.onReOrderClick = this.onReOrderClick.bind(this);
    this.hideReorderCaseDialog = this.hideReorderCaseDialog.bind(this);

    this.hideMoveToMapDialog = this.hideMoveToMapDialog.bind(this);
    this.onMoveToMapClick = this.onMoveToMapClick.bind(this);
    this.hideMoveToSchedulingDialog = this.hideMoveToSchedulingDialog.bind(this);
    this.onMoveToSchedulingClick = this.onMoveToSchedulingClick.bind(this);
    this.getQuickListCountWrapped = this.getQuickListCountWrapped.bind(this);
    this.getQuickListResultWrapped = this.getQuickListResultWrapped.bind(this);
    this.refreshCountsForTab = this.refreshCountsForTab.bind(this);

    this.mounted = { current: true };
    this.multipleLastNote = "";
    this.isNoteExternal = false;

    const getCurrentQuicklist = id => {
      return props.quickLists.find(q => q.id === id);
    };

    this.state = {
      headerClassName: "header-contracted",
      selectedQuickList: props.currentQuicklistId ? getCurrentQuicklist(props.currentQuicklistId) : null,
      showEditor: false,
      showGroup: false,
      groupNames: [],
      selectedGroup: "",
      showAssignmentDialog: false,
      selectedControlIdNumber: null,
      caseType: null,
      showMCaseView: false,
      selectedIndexes: [],
      reviewerQuicklistSelected: false,
      showUnderwriterAssignDialog: false,
      showUnderwriterUnassignDialog: false,
      showGetNextCaseWarningDialog: false,
      showQaUnassignDialog: false,
      noCasesToGetNext: false,
      showQaAssignDialog: false,
      addMultipleMode: "",
      multipleAppraiserEta: null,
      showIncidentAssignDialog: false,
      enabledFeatures: [],
      showReorderCaseDialog: false,
      showMoveToMapDialog: false,
      showMoveToSchedulingDialog: false,
    };

    // array of quick list ids that we are waiting for a request to return for its share guid before generating an entire share guid link
    this.shareGuidRequests = [];
  }

  componentDidMount() {
    this.props.getQuickLists(false, this.getFilterValues);
    if (!this.props.gotInitialGridFilterMenus && !this.props.fetchingGridFilterMenus) {
      this.props.getGridFilterMenus();
    }
  }

  componentDidUpdate(prevProps) {
    const { quickLists, currentQuicklistId, setCurrentQuicklistId, quickFilterContext } = this.props;
    const { groupNames } = this.state;

    // When navigating home while viewing a case (e.g. from / to /refresh),
    // the component stays mounted since both routes render QuickLists.
    // Detect the pathname change and close the case view.
    if (this.state.showMCaseView && this.props.location?.pathname !== prevProps.location?.pathname) {
      this.setState({ showMCaseView: false });
      this.props.clearHeader();
    }

    if (currentQuicklistId) {
      let oldQL = prevProps.quickLists.find(ql => ql.id === currentQuicklistId);
      let newQL = quickLists.find(ql => ql.id === currentQuicklistId);
      if (!newQL) {
        this.setState({ selectedIndexes: [] });
        setCurrentQuicklistId(0);
      }
      else if ((oldQL.result && oldQL.result.asOfDate) != (newQL.result && newQL.result.asOfDate)) {
        this.setState({ selectedQuickList: newQL, selectedIndexes: [] });
        setCurrentQuicklistId(newQL.id);
      }
    }

    if (quickLists.length > 0) {
      if (quickLists.length !== prevProps.quickLists.length || groupNames.length === 0 || !this.areSetsEqual(new Set([...prevProps.quickLists].map(l => l.group)), new Set([...quickLists].map(l => l.group)))) {
        const uniqueGroups = [];
        quickLists.forEach(ql => {
          if (uniqueGroups.indexOf(ql.group) === -1) {
            uniqueGroups.push(ql.group);
          }
        });
        this.setState({ groupNames: uniqueGroups });
      }
    }

    if (prevProps.quickFilterContext.filtersLastAppliedOn !== quickFilterContext.filtersLastAppliedOn) {
      this.refreshCountsForTab();
      if (this.state.selectedQuickList) this.onQuickListMenuClick(this.state.selectedQuickList.id);
    }

    if (!prevProps.quickListTemplates?.length && this.props.quickListTemplates?.length) this.props.quickFilterContext.loadTemplates(this.props.quickListTemplates);
  }

  componentWillUnmount() {
    this.props.clearHeader();
    this.mounted.current = false;
  }

  areSetsEqual = (a, b) => a.size === b.size && [...a].every(value => b.has(value));

  getQuickListCountWrapped(ql) {
    this.props.getQuickListCount(ql, this.getQuickFiltersForServer());
  }

  getQuickListResultWrapped(ql) {
    this.props.getQuickListResult(ql, this.getQuickFiltersForServer());
  }

  //Filter value editors can be found in ValueEditor.js
  getFilterValues = response => {
    if (response?.quickListTemplates?.length && this.props.canEditQuicklists) {
      // Get a list of all filter types in available templates without duplicates
      let collectedFilterTypes = [...new Set(response.quickListTemplates.flatMap(templates => templates.filterFields.map(filter => filter.inputType)))];
      // Only get filter options if filter type is present
      collectedFilterTypes.forEach(f => {
        switch (f) {
          case filterTypes.appraiserManagers:
            if (Object.keys(this.props.appraiserManagers).length === 0 && !this.props.fetchingAppraiserManagers) {
              this.props.getAppraiserManagers();
            }
            break;
          case filterTypes.valuationCoordinators:
            if (this.props.canViewEmployeeContactInfo && Object.keys(this.props.valuationCoordinators).length === 0 && !this.props.fetchingValuationCoordinators) {
              this.props.getValuationCoordinators();
            }
            break;
          case filterTypes.valuationDirectors:
            if (this.props.canViewEmployeeContactInfo && Object.keys(this.props.valuationDirectors).length === 0 && !this.props.fetchingValuationDirectors) {
              this.props.getValuationDirectors();
            }
            break;
          case filterTypes.states:
            if (this.props.stateList.length === 0 && !this.props.fetchingStateList) {
              this.props.getStateList();
            }
            break;
          case filterTypes.surveyTypes:
            if (this.props.allSurveyTypes.length === 0 && !this.props.fetchingAllSurveyTypesList) {
              this.props.getAllSurveyTypes();
            }
            break;
          case filterTypes.underwriters:
            if (this.props.underwriters.length === 0 && !this.props.fetchingUnderwriters) {
              this.props.getUnderwriters();
            }
            break;
          case filterTypes.busOpsDirectors:
          case filterTypes.qualityAssuranceDirector:
            if (this.props.canViewEmployeeContactInfo && this.props.busOpsDirectors.length === 0 && !this.props.fetchingBusOpsDirectors) {
              this.props.getBusOpsDirectors();
            }
            break;
          case filterTypes.busOpsManagers:
          case filterTypes.qualityAssuranceManager:
            if (this.props.canViewEmployeeContactInfo && this.props.busOpsManagers.length === 0 && !this.props.fetchingBusOpsManagers) {
              this.props.getBusOpsManagers();
            }
            break;
          case filterTypes.customerServiceAssignUsers:
            if (this.props.canAssignIncidents && this.props.assignToUsers.length === 0 && !this.props.isFetchingAssignToUsers) {
              this.props.getCustomerServiceAssignToUsers();
            }
            break;
          case filterTypes.appraiserAssigned:
            if (this.props.canViewAppraisers && this.props.minimalAppraiserList.length === 0 && !this.props.fetchingMinimalAppraiserList) {
              this.props.getMinimalAppraiserList();
            }
            break;
          case filterTypes.reviewerActions:
            if (this.props.allCustomerActionsForUser?.length === 0 && !this.props.fetchingAllCustomerActionsForUser) {
              this.props.getAllCustomerActionsForUser();
            }
            break;
          case filterTypes.county:
            if (this.props.allCounties.length === 0 && !this.props.isFetchingAllCounties) {
              this.props.getAllCounties();
            }
            break;
          case filterTypes.exportType:
            if (this.props.exportTypes.length === 0 && !this.props.fetchingExportTypes && this.props.canViewExports) {
              this.props.getExportTypes();
            }
            break;
          case filterTypes.fieldDevelopmentManager:
            if (this.props.fieldDevelopmentManagers.length === 0 && !this.props.fetchingFieldDevelopmentManagers && this.props.canViewFrProfile) {
              this.props.getAllFieldDevelopmentManagers();
            }
            break;
          case filterTypes.lenderLogisticsManager:
            if (this.props.lenderLogisticsManagers.length === 0 && !this.props.isFetchingLenderLogisticsManagers) {
              this.props.getAllLenderLogisticsManagers();
            }
            break;
          case filterTypes.serviceRegion:
            if (this.props.serviceRegions?.length === 0) {
              this.props.getAllServiceRegions();
            }
            break;
          case filterTypes.fieldOperationsManager:
            if (this.props.fieldOperationsManager?.length === 0 && !this.props.isFetchingFieldOperationsManagers) {
              this.props.getAllFieldOperationsManagers();
            }
            break;
          case filterTypes.customerExperienceManagers:
            if (this.props.customerExperienceManagers?.length === 0 && !this.props.isFetchingCustomerExperienceManagers) {
              this.props.getCustomerExperienceManagers();
            }
            break;
          case filterTypes.customerExperienceDirectors:
            if (this.props.customerExperienceDirectors?.length === 0 && !this.props.isFetchingCustomerExperienceDirectors) {
              this.props.getCustomerExperienceDirectors();
            }
            break;
        }
      });
    }
  }

  getQuickFiltersForServer() {
    return this.props.quickFilterContext?.getQuickFilters();
  }

  onQuickListMenuClick(qlId) {
    //setting selectedQuickList to null here so the spinner shows when clicking between quicklists
    this.setState({ selectedQuickList: null });
    this.props.setCurrentQuicklistId(qlId);
    let ql = this.props.quickLists.find(ql => ql.id === qlId);
    if (ql) {
      this.getQuickListCountWrapped(ql);
      this.getQuickListResultWrapped(ql);
    }
    this.fixGridHeight();
  }

  refreshCountsForTab(selectedGroup = this.state.selectedGroup) {
    const { quickLists } = this.props;

    if (!selectedGroup) selectedGroup = this.state.groupNames[0];

    quickLists.filter(ql => ql.group === selectedGroup).map((ql) => this.getQuickListCountWrapped(ql));
  }

  onTabChange(tabIndex) {
    const { groupNames } = this.state;
    const selectedGroup = groupNames[tabIndex];
    this.refreshCountsForTab(selectedGroup);
    this.setState({ selectedGroup });
  }

  onAddClick(event) {
    if (event && event.stopPropagation) event.stopPropagation();
    this.setState({ showEditor: true });
  }

  onShareGroupClick(tabIndex) {
    const { orthosRoot } = WebConfig;

    getQuickListShareGuidsByGroupName(this.state.groupNames[tabIndex], shareGuids => {
      let url = `${orthosRoot}/webui/get-shared-quick-list?shareGuids=${shareGuids}&copy=1`;
      const copyUrl = () => navigator.clipboard.writeText(url);
      this.context.showYesNo("Copy Quick List Group", "Press Copy Url to share a copy of the quick list group", copyUrl, null, "Copy Url", "Cancel");
    }, this.mounted);
  }

  renderEditor() {
    let newQuickList = { createMode: true };

    //if simple mode edit tempateList

    return (<QuickListEdit
      templateList={this.props.quickListTemplates}
      currentGroupNames={[...new Set(this.props.quickLists.map(ql => ql.group))]}
      id={0}
      item={newQuickList}
      onApply={this.onApplyClick}
      onClose={this.onCloseClick} />);
  }

  onApplyClick(quickList) {
    this.setState({ showEditor: false });
    this.props.saveQuickList(quickList);
  }

  onCloseClick(e) {
    e.stopPropagation();
    this.setState({ showEditor: false, showGroup: false });
  }

  onGroupClick() {
    this.setState({ showGroup: true });
  }

  renderGroup() {
    return (<QuickListGroup
      groupNames={this.state.groupNames}
      onApply={this.onApplyGroupClick}
      onClose={this.onCloseClick} />);
  }

  onApplyGroupClick(items) {
    this.setState({ showGroup: false });
    this.props.saveQuickListGroup(items);
  }

  // Take QuickList to Assignment Tool
  onAssignmentClick(event) {
    event.stopPropagation();
    this.props.getCaseLocationsCount(ASSIGNMENT_MODE_APPRAISAL, null, this.state.selectedQuickList.result.data.map(c => c.controlIDNumber));
    this.props.getCaseLocationsCount(ASSIGNMENT_MODE_INSURANCE, null, this.state.selectedQuickList.result.data.map(c => c.controlIDNumber));
    this.setState({ showAssignmentDialog: true });
  }

  confirmAddMultiple(cases) {
    switch (this.state.addMultipleMode) {
      case UPDATE_APPRAISAL_ETA:
        (new Date(this.state.multipleAppraiserEta) > new Date())
          ? cases.forEach(c => updateETA(c.controlIDNumber, TYPE_CODE_APPRAISER_DELIVERY, this.state.multipleAppraiserEta, () => this.props.makeToast(`Case ${c.controlIDNumber} successfully updated.`, "success"), this.mounted))
          : this.props.makeToast("Please select a date in the future.", "error");
        this.setState({ addMultipleMode: "", multipleAppraiserEta: null });
        break;
      case UPDATE_LAST_NOTE:
        cases.forEach(c => {
          let payload = {
            noteBody: this.multipleLastNote,
            isExternal: this.isNoteExternal,
          };
          addCaseNote(c.controlIDNumber, CASE_NOTE_TYPE_GENERAL, payload, () => this.props.makeToast(`Case ${c.controlIDNumber} successfully updated.`, "success"), this.mounted);
        });
        this.setState({ addMultipleMode: "" });
        this.multipleLastNote = "";
        this.isNoteExternal = false;
        break;
    }
  }

  showConfirmAddMultipleDialog() {
    if (!this.state.selectedIndexes.length) return this.props.makeToast(`Must select cases before trying to update ${this.state.addMultipleMode === UPDATE_APPRAISAL_ETA ? "appraiser ETA" : "last note"}. Please try again.`, "warning");
    if (this.state.addMultipleMode === UPDATE_APPRAISAL_ETA && !this.state.multipleAppraiserEta) return this.props.makeToast("Must select a date before saving. Please try again.", "warning");
    if (this.state.addMultipleMode === UPDATE_LAST_NOTE && !this.multipleLastNote.length) return this.props.makeToast("Must enter a note before saving. Please try again.", "warning");
    let found = this.state.selectedIndexes.map(i => this.state.selectedQuickList.result.data[i]);
    this.context.showYesNo("Update Multiple",
      <div key={"update-multiple-container"} className={"update-multiple-container"}>
        Are you sure you want to update cases: {found.map(c => <div key={`update-multiple-controlNums-${c.controlIDNumber}`}>{c.controlIDNumber}</div>)}
      </div>, () => this.confirmAddMultiple(found), () => {
        this.setState({ addMultipleMode: "", multipleAppraiserEta: null });
        this.multipleLastNote = "";
      });
  }

  setMultipleLastNote(note) {
    this.multipleLastNote = note;
  }

  onNoteSave(note, noteType) {
    this.setMultipleLastNote(note);
    this.isNoteExternal = noteType === NOTE_EXTERNAL;
    this.showConfirmAddMultipleDialog();
  }

  onNoteCancel() {
    this.setState({ addMultipleMode: "", multipleAppraiserEta: null, multipleLastNote: null });
    this.context.hide();
  }

  addMultipleLastNote(event) {
    event.stopPropagation();
    this.setState({ addMultipleMode: UPDATE_LAST_NOTE });
    let children = [<NoteInputField
      key="bulk-note-input-field"
      setNote={this.setMultipleLastNote}
      placeholder="Add note"
      showNoteType={true}
      saveNote={this.onNoteSave}
      showAsDialog={true}
      onCancel={this.onNoteCancel}
      saveButtonLabel={"Update Multiple"}
    />];
    let actions = [];
    let dialogProps = { width: 600 };
    this.context.show("Update Last Note", children, actions, dialogProps);
  }

  addMultipleAppraiserEta(event) {
    event.stopPropagation();
    this.setState({ addMultipleMode: UPDATE_APPRAISAL_ETA });
    let children = [<MField key={"update-appraiserEta"} id={"update-appraiserEta"} dataType={DATA_TYPE_DATE_TIME} hideDatePickerLabel onChange={(e, i) => {
      let formatted = moment(i).format("YYYY-MM-DD HH:mm:ss");
      this.setState({ multipleAppraiserEta: formatted });
    }} value={this.state.multipleAppraiserEta || ""} />];
    let actions = [{ label: "Update Multiple", isPrimary: true, onClick: this.showConfirmAddMultipleDialog }, { label: "Cancel", isPrimary: false, onClick: () => this.setState({ addMultipleMode: "", multipleAppraiserEta: null, multipleLastNote: null }) }];
    let dialogProps = { className: "update-multiple" };
    this.context.show("Update Appraiser ETA", children, actions, dialogProps);
  }

  loadAssignmentToolWithCases(mode) {
    this.props.history.push({
      pathname: mode === ASSIGNMENT_MODE_INSURANCE ? "assignment-tool-insurance" : "assignment-tool-appraisal",
      state: { caseIdFilter: this.state.selectedQuickList.result.data.map(c => c.controlIDNumber), caseIdFilterName: this.state.selectedQuickList.name }
    });
  }

  hideAssignmentDialog() {
    this.setState({ showAssignmentDialog: false });
  }

  // Grid handlers
  formStatusChange() { }
  expandCollapseClicked() { this.fixGridHeight(); }
  fixGridHeight() {
    //sad hack to make the mgrid render properly, we need to figure out a real solution to this, one resize wont work depending on the computer, we need a ton so they keep going after the expander is opened
    for (let i = 0; i < 5; i++)setTimeout(() => window.dispatchEvent(new Event("resize")), i * 1000);
  }
  clearNullFromColumnDefs(colDefs) {
    if (colDefs == null || colDefs == undefined) return [];
    let trimmed = colDefs.map(cd => Object.keys(cd).reduce((acc, key) => {
      if (cd[key] !== null) acc[key] = cd[key];
      return acc;
    }, {}));
    return trimmed;
  }

  navigateToCase(options) { // options object for additional handling

    // Initial Tab: Option for specific tab being selected on open
    let firstTab = options && options.firstTab ? options.firstTab : null;
    let secondTab = options && options.secondTab ? options.secondTab : null;

    // Set state
    this.setState({ showMCaseView: true, initialTabs: { first: firstTab, second: secondTab } });

    const buttons = [
      {
        name: "Back to Quick Lists",
        onClick: () => {
          this.setState({ showMCaseView: false });
          this.props.clearHeaderDefinitions(buttons);
        }
      }
    ];

    if (this.isSelectableQuicklist()) {
      buttons.push({
        name: "Get Next",
        onClick: () => {
          getNextCase((response) => {
            if (response.controlIdNumber === this.state.selectedControlIdNumber) {
              this.setState({ showGetNextCaseWarningDialog: true, noCasesToGetNext: false });
            } else if (response.isEmpty) {
              this.setState({ showGetNextCaseWarningDialog: true, noCasesToGetNext: true });
            } else {
              this.setState({ selectedControlIdNumber: response.controlIdNumber, noCasesToGetNext: false });
            }
          }, this.mounted);
        }
      });
    }

    this.props.updateHeader({
      dropdownTitle: "Quick Lists",
      buttons
    });
  }

  openInPanel(rowIndex) {
    this.props.setCurrentQuicklistRowIndex(rowIndex);
    if (nonCaseBasedTemplateCodes.includes(this.state.selectedQuickList.template.templateCode)) {
      return;
    }
    let row = this.state.selectedQuickList.result.data[rowIndex];
    // Legacy case header relies on these prefetched requests, but CaseHeaderV2 loads its own data.
    if (!this.props.showCaseHeaderV2 && !this.state.selectedControlIdNumber) {
      this.props.getCaseHeader(row.controlIDNumber);
      if (row.customerNumber) getEnabledFeatures(row.customerNumber, (r) => this.setState({ enabledFeatures: r.features }), this.mounted);
    }
    if (!this.props.showCaseHeaderV2) {
      this.props.getHistory(row.controlIDNumber);
    }
    this.setState({ selectedControlIdNumber: row.controlIDNumber, caseType: row.resultGridRowType });
  }

  openWithRouter() {
    this.navigateToCase();
  }

  getMapPinForRow(i) {
    let row = this.state.selectedQuickList.result.data[i];
    return {
      latitude: row.latitude,
      longitude: row.longitude,
      iconURL: getCasePinURL("red", false, false)
    };
  }

  getMapToolTipForRow(i) {
    let row = this.state.selectedQuickList.result.data[i];
    let appointmentDate = null;

    if (row.appointmentDate) {
      appointmentDate = dateToStringYy(row.appointmentDate);
    } else if (row.fieldAppointmentRequired === true) { // explicit check for true or false, because if the property doesnt exist then we just wont show the appointment date field
      appointmentDate = "Not Provided";
    } else if (row.fieldAppointmentRequired === false) {
      appointmentDate = "Not Required";
    }

    let fields = [
      { label: "Borrower", value: row.policyholderName },
      { label: "Address", value: `${row.address} ${row.city}` },
      { label: "Survey Type", value: row.inspectionType },
      { label: "Due Date", value: row.dueDate, dataType: DATA_TYPE_DAYS_ELAPSED },
    ];

    if (appointmentDate !== null) {
      fields.push({ label: "Appointment Date", value: appointmentDate });
    }

    return {
      title: `Control # ${row.controlIDNumber}`,
      fields: fields,
    };
  }

  isSelectableQuicklist() {
    const { selectedQuickList } = this.state;
    if (!selectedQuickList) {
      return false;
    }
    return selectedQuickList.template && selectedQuickList.template.clientConfiguration?.hasSelectableRows;
  }

  // Assign/Unassign to Underwriters
  onUnderwriterAssignClick(event) {
    event.stopPropagation();
    this.setState({ showUnderwriterAssignDialog: true });
  }

  hideUnderwriterAssign() {
    this.setState({ showUnderwriterAssignDialog: false });
  }

  onUnderwriterUnassignClick(event) {
    event.stopPropagation();
    this.setState({ showUnderwriterUnassignDialog: true });
  }

  hideUnderwriterUnassign() {
    this.setState({ showUnderwriterUnassignDialog: false });
  }

  getSelectedQaCases() {  // QA action needs queue id
    const { selectedIndexes, selectedQuickList } = this.state;
    if (!selectedIndexes.length || !selectedQuickList) return [];
    return selectedIndexes.map(i => {
      return {
        controlIDNumber: selectedQuickList.result.data[i].controlIDNumber,
        qaQueueId: selectedQuickList.result.data[i].qaQueueId
      };
    });
  }

  getSelectedControlNumbers() {
    const { selectedIndexes, selectedQuickList } = this.state;
    if (!selectedIndexes.length || !selectedQuickList) return [];
    return selectedIndexes.map(i => selectedQuickList.result.data[i].controlIDNumber);
  }

  getSelectedIncidents() {
    const { selectedIndexes, selectedQuickList } = this.state;
    if (!selectedIndexes.length || !selectedQuickList) return [];
    return selectedIndexes.map(i => selectedQuickList.result.data[i].incidentId);
  }

  // Assign to QA users
  onQaAssignClick(event) {
    event.stopPropagation();
    this.setState({ showQaAssignDialog: true });
  }

  hideQaAssignDialog() {
    this.setState({ showQaAssignDialog: false });
  }

  onQaUnassignClick(event) {
    event.stopPropagation();
    this.setState({ showQaUnassignDialog: true });
  }

  hideQaUnassignDialog() {
    this.setState({ showQaUnassignDialog: false });
  }

  // Field Scheduling Actions
  onMoveToMapClick(event) {
    event.stopPropagation();
    this.setState({ showMoveToMapDialog: true });
  }

  hideMoveToMapDialog() {
    this.setState({ showMoveToMapDialog: false });
  }

  onMoveToSchedulingClick(event) {
    event.stopPropagation();
    this.setState({ showMoveToSchedulingDialog: true });
  }

  hideMoveToSchedulingDialog() {
    this.setState({ showMoveToSchedulingDialog: false });
  }

  // Bulk Auto QA
  onAddBulkAutoQA(event) {
    event.stopPropagation();
    let actions = [{
      label: "Confirm", isPrimary: true, onClick: () => {
        let controlIdNumbers = this.getSelectedControlNumbers();
        runBulkAutoQAProcess(controlIdNumbers, this.props.makeToast("Auto QA batch added.", "success"), this.mounted);
      }
    }, { label: "Cancel", isPrimary: false }];
    this.context.show(null, "Run Auto-QA Process on Selected Cases", actions);
  }

  bulkPutCaseOnHold(event) {
    event.stopPropagation();

    const bulkPutOnHold = (offHoldDate, onHoldNote) => {
      this.context.show("Putting cases on hold", <MSpinner />);
      putOnHold(this.getSelectedControlNumbers(), this.props.internetUserId, offHoldDate, onHoldNote, (onHoldResponse) => {
        let errored = onHoldResponse.filter(r => !r.success);
        if (errored.length) {
          let errorMessage = <>
            Failed to put the following Control Numbers on hold:
            <br />
            {errored.map(e => e.controlIdNumber).join(", ")}
            <br />
            <br />
            Please ensure the cases are valid for placing on hold (case is not already on hold, case is not completed or closed) before trying again.
          </>;

          this.context.show(
            "On Hold Error",
            errorMessage,
            [{ label: "Ok", isPrimary: true, onClick: () => this.context.hide() }],
            { width: 500 },
          );
        } else {
          this.props.makeToast("All cases have been successfully put on hold", "success");
          this.context.hide();
        }
      }, null, this.mounted);
    };

    let dateRef = { current: null };
    let noteRef = { current: null };

    let children = <>
      Set Off-Hold Date? (optional)
      <MField
        key="pick-bulk-on-hold-date"
        id="pick-bulk-on-hold-date"
        dataType={DATA_TYPE_DATE}
        onChange={(e, date) => dateRef.current = date}
        hideDatePickerLabel
      />
      Case Hold Note (optional)
      <MField
        key="pick-bulk-on-hold-note"
        id="pick-bulk-on-hold-note"
        dataType={DATA_TYPE_STRING}
        onChange={(e, i) => noteRef.current = i}
      />
    </>;

    let actions = [
      { label: "Confirm", isPrimary: true, onClick: () => bulkPutOnHold(dateRef.current, noteRef.current) },
      { label: "Cancel", isPrimary: false },
    ];

    this.context.show("Place on Hold", children, actions);
  }

  // Assign Customer Service Incidents
  onIncidentAssignClick(event) {
    event.stopPropagation();
    this.setState({ showIncidentAssignDialog: true });
  }

  hideIncidentAssignDialog() {
    this.setState({ showIncidentAssignDialog: false });
  }

  generateList(groupName) {
    const { quickLists, quickListTemplates, saveQuickList, deleteQuickList, currentQuicklistId } = this.props;
    if (!quickLists || quickLists.length == 0) return null;

    let selectedQuickListId = currentQuicklistId;
    if (!selectedQuickListId) {
      selectedQuickListId = quickLists[0].id;
    }
    let qList = quickLists.filter(q => (q.group === groupName));

    qList = qList.sort((a, b) => a.sortOrder - b.sortOrder);

    return (
      <Carousel
        dragging={false}
        slidesToShow={6}
        slidesToScroll={3}
        cellSpacing={10}
        slideWidth={"170px"}
        initialSlideHeight={160}
        autoGenerateStyleTag={true}
        renderBottomCenterControls={() => null}
        framePadding={"0px 35px"}
        renderCenterLeftControls={({ previousSlide }) => (<IconButton onClick={previousSlide}><Icon>arrow_back_ios</Icon></IconButton>)}
        renderCenterRightControls={({ nextSlide }) => (<IconButton onClick={nextSlide}><Icon>arrow_forward_ios</Icon></IconButton>)}
      >
        {qList.map((q, index) => {
          return (<QuickList
            key={index.toString()}
            templateList={quickListTemplates}
            currentGroupNames={[...new Set(this.props.quickLists.map(ql => ql.group))]}
            item={q}
            getCount={this.getQuickListCountWrapped}
            getResult={this.getQuickListResultWrapped}
            onClick={this.onQuickListMenuClick}
            isSelected={selectedQuickListId === q.id}
            canEdit={this.props.canEditQuicklists && q.isEditable}
            canShare={this.props.canShareQuicklists}
            isSharedWithThisUser={q.isSharedWithThisUser}
            onSave={saveQuickList}
            onDelete={deleteQuickList}
            onReloadLists={() => this.props.getQuickLists(true)}
          />);
        })}
      </Carousel>
    );
  }

  onReOrderClick(event) {
    event.stopPropagation();
    this.setState({showReorderCaseDialog: true});
  }

  hideReorderCaseDialog(){
    this.setState({showReorderCaseDialog: false});
  }

  getGridActions() {
    const actions = [ACTION_CONFIGURE, ACTION_MAP, ACTION_DOWNLOAD];
    if (this.isSelectableQuicklist()) {
      switch (this.state.selectedQuickList.template.templateCode) {
        case quickListTemplateCode.customerReviewQueue:
        case quickListTemplateCode.customerInsuranceCases:
          if (this.props.rights.includes(UNDERWRITER_ASSIGN)) {
            actions.push({
              icon: "assignment_late",
              helpText: "Unassign from Underwriters",
              onClick: this.onUnderwriterUnassignClick
            });
            actions.push({
              icon: "assignment_ind",
              helpText: "Assign to Underwriter",
              onClick: this.onUnderwriterAssignClick
            });
          }
          break;
        case quickListTemplateCode.qualityAssuanceInsurance:
          if (this.props.canAssignQA) {
            actions.push({ icon: "assignment_late", helpText: "Unassign from QA Agents", onClick: this.onQaUnassignClick });
            actions.push({ icon: "assignment_ind", helpText: "Assign to QA Agent", onClick: this.onQaAssignClick });
          }
          if (this.props.canAddBulkAutoQA && this.getSelectedControlNumbers().length > 0) {
            actions.push({ icon: "playlist_add", helpText: "Add Bulk Auto QA", onClick: this.onAddBulkAutoQA });
          }
          if (this.props.canBulkPutOnHold && this.getSelectedControlNumbers().length > 0) {
            actions.push({ icon: "pending_actions", helpText: "Place on Hold", onClick: this.bulkPutCaseOnHold });
          }
          break;
        case quickListTemplateCode.qualityAssuranceRequireAudit:
          if (this.props.canAddBulkAutoQA && this.getSelectedControlNumbers().length > 0) {
            actions.push({ icon: "playlist_add", helpText: "Add Bulk Auto QA", onClick: this.onAddBulkAutoQA });
          }
          break;
        case quickListTemplateCode.insuranceCases:
          if (this.props.canAssignField) {
            actions.push({ icon: "map", helpText: "Open in Assignment Tool", onClick: this.onAssignmentClick });
            if (this.state.selectedIndexes.length) {
              actions.push({ icon: "note_add", helpText: "Add Multiple Last Note", onClick: this.addMultipleLastNote });
            }
          }
          if(this.props.canManageFieldScheduling && this.getSelectedControlNumbers().length){
            actions.push({ icon: "add_location_alt", helpText: "Move to Map", onClick: this.onMoveToMapClick });
            actions.push({ icon: "add_ic_call", helpText: "Move to Scheduling", onClick: this.onMoveToSchedulingClick });
          }
          break;
        case quickListTemplateCode.appraisalCases:
          if (this.props.canAssignField) {
            actions.push({ icon: "map", helpText: "Open in Assignment Tool", onClick: this.onAssignmentClick });
            if (this.state.selectedIndexes.length) {
              actions.push({ icon: "note_add", helpText: "Add Multiple Last Note", onClick: this.addMultipleLastNote },
                { icon: "event", helpText: "Add Multiple Appraiser ETA", onClick: this.addMultipleAppraiserEta });
            }
          }
          break;
        case quickListTemplateCode.homeownerOpenIncidents:
          if (this.props.canAssignIncidents) {
            actions.push({ icon: "assignment_ind", helpText: "Assign Incident", onClick: this.onIncidentAssignClick });
          }
          break;
      }
      if (this.props.canOrder && this.getSelectedControlNumbers().length === 1) {
        actions.push({ icon: "add", helpText: "Re-Order Case", onClick: this.onReOrderClick });
      }
    }
    return actions;
  }

  getTabBarActions() {
    let actions = [];
    if (this.props.canEditQuicklists) {
      actions.push({ icon: "add", helpText: "Add New", onClick: this.onAddClick }, { icon: "settings", helpText: "Settings", onClick: this.onGroupClick });
    }
    if (this.props.canShareQuicklistGroup && this.state.selectedGroup !== "Shared") {
      actions.push({ icon: "share", helpText: "Copy Group", onClick: this.onShareGroupClick });
    }

    return actions;
  }

  getPushToPaneTabs() {
    // This kind of sucks, but I don't have a better strategy at the moment
    // for enabling this behavior outside of the design I employed with QA View
    // (which, sadly, doesn't work well with QuickLists at the moment)
    const { caseHeader, roles } = this.props;
    let tabsForPane = [];
    // Photos
    if ((caseHeader?.caseInfo?.primaryStatus === PrimaryStatus.COMPLETED && isCustomer(roles))
      || this.props.hasFormPhotoSplitView) {
      tabsForPane.push("Photos");
    }
    // Default
    return tabsForPane;
  }

  navigateToHiringNeed(rowIndex) {
    let row = this.state.selectedQuickList.result.data[rowIndex];
    this.props.history.push({
      pathname: "/hiring-need",
      state: {
        id: row.inspectorHiringForecastId
      }
    });
  }

  getDialogs() {
    if (this.isSelectableQuicklist()) {
      switch (this.state.selectedQuickList.template.templateCode) {
        case quickListTemplateCode.customerReviewQueue:
        case quickListTemplateCode.customerInsuranceCases:
          if (this.props.rights.includes(UNDERWRITER_ASSIGN)) {
            return (<>
              <UnderwriterAssign
                  visible={this.state.showUnderwriterAssignDialog}
                  hideDialog={this.hideUnderwriterAssign}
                  controlNumbers={this.getSelectedControlNumbers()}
                  selectedQuickListId={this.props.currentQuicklistId}
              />
              <UnderwriterUnassign
                  visible={this.state.showUnderwriterUnassignDialog}
                  hideDialog={this.hideUnderwriterUnassign}
                  controlNumbers={this.getSelectedControlNumbers()}
                  selectedQuickListId={this.props.currentQuicklistId}
              />
            </>);
          } else {
            return null;
          }
        case quickListTemplateCode.qualityAssuanceInsurance:
        case quickListTemplateCode.qualityAssuranceRequireAudit:
          if (this.props.canAssignQA) {
            return (<>
              <QualityAssuranceAssign
                visible={this.state.showQaAssignDialog}
                hideDialog={this.hideQaAssignDialog}
                selectedCases={this.getSelectedQaCases()}
                selectedQuickListId={this.props.currentQuicklistId}
              />
              <QualityAssuranceUnassign
                visible={this.state.showQaUnassignDialog}
                hideDialog={this.hideQaUnassignDialog}
                controlNumbers={this.getSelectedControlNumbers()}
                selectedQuickListId={this.props.currentQuicklistId}
              />
            </>);
          }
          break;
        case quickListTemplateCode.insuranceCases:
          return (<>
            <MoveToMap
              visible={this.state.showMoveToMapDialog}
              hideDialog={this.hideMoveToMapDialog}
              insuranceCases={this.getSelectedControlNumbers()}
            />
            <MoveToScheduling
              visible={this.state.showMoveToSchedulingDialog}
              hideDialog={this.hideMoveToSchedulingDialog}
              insuranceCases={this.getSelectedControlNumbers()}
            />
          </>);
        case quickListTemplateCode.appraisalCases:
          if (this.props.canAssignField) {
            return (
              <CaseAssignment
                insuranceCaseCount={this.props.insuranceCaseCount}
                appraisalCaseCount={this.props.appraisalCaseCount}
                visible={this.state.showAssignmentDialog}
                hideDialog={this.hideAssignmentDialog}
                openAssignment={this.loadAssignmentToolWithCases}
              />);
          }
          break;
        case quickListTemplateCode.homeownerOpenIncidents:
          if (this.props.canAssignIncidents) {
            return (
              <IncidentAssign
                selectedIncidentIds={this.getSelectedIncidents()}
                visible={this.state.showIncidentAssignDialog}
                hideDialog={this.hideIncidentAssignDialog}
                selectedQuickListId={this.props.currentQuicklistId}
              />
            );
          }
          break;
      }
    }
  }

  getSplitComponent = () => {
    if (this.props.currentRowIndex !== null) {
      switch (this.state.selectedQuickList?.templateCode) {
        case quickListTemplateCode.inspectorHiringForecastsOpen: {
          let inspectorHiringForecastId = this.state.selectedQuickList.result.data[this.props.currentRowIndex].inspectorHiringForecastId;
          return (<HiringNeed inspectorHiringForecastId={inspectorHiringForecastId} />);
        }
        case quickListTemplateCode.inspector: {
          let frData = this.state.selectedQuickList.result.data[this.props.currentRowIndex];
          return (<FieldRepProfileV2
            frNumberOverride={frData.inspectorNumber}
            internetUserIdOverride={frData.internetUserId}
            verticalDisplay
            showAbbreviatedProfile
          />);
        }
        case quickListTemplateCode.appraiser: {
          let appraiserData = this.state.selectedQuickList.result.data[this.props.currentRowIndex];
          return (<AppraiserProfilePanel
            id={appraiserData.appraiserId}
            internetUserIdForPanel={appraiserData.internetUserId}
            showHeaderButton
          />);
        }
        case quickListTemplateCode.qualityAssuranceAgent: {
          let agentData = this.state.selectedQuickList.result.data[this.props.currentRowIndex];
          return (<AgentQuickListProfile
            employeeId={agentData.employeeId}
            internetUserId={agentData.internetUserId}
          />);
        }
        default: {
          if (!this.state.selectedControlIdNumber) return;
          if (this.props.displayBrokerCaseHeader) {
            return (<BrokerCaseHeader
              controlNumber={this.state.selectedControlIdNumber}
              verticalDisplay
              navigateToCase={this.navigateToCase}
            />);
          }
          if (this.props.showCaseHeaderV2) {
            return (<CaseHeaderV2
              controlNumber={this.state.selectedControlIdNumber}
              verticalDisplay
              quickListDisplay={true}
            />);
          } else {
            return (<CaseHeader
              controlNumber={this.state.selectedControlIdNumber}
              verticalDisplay
              getCaseHeader={this.props.getCaseHeader}
              updatingCaseHeader={this.props.updatingCaseHeader}
              updateCaseHeader={this.props.updateCaseHeader}
              navigateToCase={this.navigateToCase}
              enabledFeatures={this.state.enabledFeatures}
            />);
          }
        }
      }
    }
  }

  getSplitComponentTitle = () => {
    if (this.props.currentRowIndex !== null) {
      let title = "";
      const buttonOnClick = () => {
        this.setState({ selectedControlIdNumber: null });
        this.props.setCurrentQuicklistRowIndex(null);
      };
      let buttons = [{ icon: "close", onClick: buttonOnClick }];
      switch (this.state.selectedQuickList?.templateCode) {
        case quickListTemplateCode.inspectorHiringForecastsOpen:
          title = "Hiring Needs Details";
          break;
        case quickListTemplateCode.inspector:
          title = "Field Rep Details";
          break;
        case quickListTemplateCode.appraiser:
          title = "Appraiser Profile";
          break;
        case quickListTemplateCode.qualityAssuranceAgent:
          title = "Quality Assurance Agent";
          break;
        default:
          title = "Case Profile";
          buttons.unshift({ icon: "fullscreen", onClick: () => this.navigateToCase() });
      }
      return { title, buttons };
    }
  }

  getCaseView() {
    // TODO consider moving these to a route and navigating to them instead of loading on top of quicklists
    // Current quicklist and row index are now saved in redux. Navigate back to return to quicklists in the state when left
    // idk who wrote that above but just adding on, we would want to restore where the grid is scrolled to also
    switch (this.state.caseType) {
      case "QAAudit":
        return (<SummaryAuditView controlIdNumber={this.state.selectedControlIdNumber} />);
      default:
        return (<MCaseView
          controlNumberOverride={this.state.selectedControlIdNumber}
          forcePushToPane={this.getPushToPaneTabs()}
          initialTabs={this.state.initialTabs}
        />);
    }
  }

  render() {
    const { quickLists, isFetchingQuickLists, currentQuicklistId, currentRowIndex } = this.props;
    if (!quickLists.length && isFetchingQuickLists) return <MSpinner />;
    if (!quickLists.length) {
      return (
        <Card className="padding-page-content case-header" id="quicklist-container">
          <CardContent>
            <Typography variant="h6">Quick Lists</Typography>
          </CardContent>
          <CardContent>
            <br />
            <Button id={"ql-add"}
              onClick={(event) => this.onAddClick(event)}>
              Add your first Quick List.
            </Button>
            <br />
          </CardContent>
          {this.state.showEditor && this.renderEditor()}
        </Card>
      );
    }
    const { selectedQuickList, groupNames } = this.state;
    if (groupNames.length == 0) {
      this.props.quickLists.map(ql => {
        if (groupNames.indexOf(ql.group) === -1) {
          groupNames.push(ql.group);
        }
      });
    }

    let tabs = groupNames.map(groupName => ({
      title: groupName,
      children: <div>{this.generateList(groupName)}</div>
    }));

    return (
      <>
        <div className="full-height" {... this.state.showMCaseView && { style: { display: "none" } }}>
          <MSplitter
            firstChild={
              <div className="quick-list-home-page padding-page-content" id="quicklist-container">
                {this.props.hasQuickFilters && <QuickFilterSection />}
                <MSectionCollection
                  defaultMode={MSECTION_MODE_TAB}
                  disableModeChanging={false}
                  actions={this.getTabBarActions()}
                  sections={tabs}
                  onTabChange={this.onTabChange}
                />
                {!!currentQuicklistId && !selectedQuickList && <MSpinner />}
                {selectedQuickList && selectedQuickList.result.columns &&
                  <div className="quick-list-mgrid">
                    {/*
                        We do a weird hack when showing the case view, allowing the user to go back to the quicklist page without losing their selected/loaded quick list
                        when viewing mcaseview, we dont change the route, we just load up an mcaseview control, while keeping everything loaded but hidden in the background
                        MGrid has a draggable component to allow headers to be dragged around. this component is even used when header dragging is disallowed
                        this blocks the ability to drag and drop onto the file manager for some reason
                        so now when showing mcaseview we will conditionally unrender the grid
                    */}
                    {!this.state.showMCaseView && <MGrid
                      headerText={selectedQuickList.name}
                      columnDefinitions={this.clearNullFromColumnDefs(selectedQuickList.result.columns)}
                      data={selectedQuickList.result.data}
                      actions={this.getGridActions()}
                      onRowClick={(row) => this.openInPanel(row)}
                      rowLastClicked={currentRowIndex}
                      getMapPinForRow={this.getMapPinForRow}
                      getMapToolTipForRow={this.getMapToolTipForRow}
                      onCellButtonClick={this.openWithRouter}
                      allowRowSelection={this.isSelectableQuicklist()}
                      onRowSelectionChanged={indexes => this.setState({ selectedIndexes: indexes })}
                      selectedRows={this.state.selectedIndexes}
                      dataLastChanged={selectedQuickList.result.asOfDate}
                    />}
                  </div>
                }
                {this.state.showEditor && this.renderEditor()}
                {this.state.showGroup && this.renderGroup()}
                {this.getDialogs()}
                {this.state.showReorderCaseDialog &&
                  <CaseDuplicateAsDialog
                      controlNumber={this.getSelectedControlNumbers()[0]}
                      visible={true}
                      hideDialog={this.hideReorderCaseDialog}
                  />}
              </div>
            }
            secondChild={this.getSplitComponent()}
            secondChildTitle={this.getSplitComponentTitle()}
          />
        </div>

        <MDialog
          id="get-next-case-warning-dialog"
          visible={this.state.showGetNextCaseWarningDialog}
          contentActions={<Button key="send-button" onClick={() => this.setState({ showGetNextCaseWarningDialog: false })}>Ok</Button>}
          title={"Warning"}
        >
          {this.state.noCasesToGetNext ? "You have no more policies assigned." : "The current policy must be marked as reviewed prior to getting the next policy."}
        </MDialog>
        {this.state.showMCaseView && this.getCaseView()}

      </>
    );
  }
}

StaticQuickLists.propTypes = {
  history: PropTypes.object,
  location: PropTypes.shape({ pathname: PropTypes.string }),
  getQuickListCount: PropTypes.func.isRequired,
  getQuickListResult: PropTypes.func.isRequired,
  getQuickLists: PropTypes.func.isRequired,
  isFetchingQuickLists: PropTypes.bool.isRequired,
  quickLists: PropTypes.array.isRequired,
  quickListTemplates: PropTypes.array.isRequired,
  deleteQuickList: PropTypes.func.isRequired,
  saveQuickList: PropTypes.func.isRequired,
  saveQuickListGroup: PropTypes.func.isRequired,
  rights: PropTypes.array.isRequired,
  roles: PropTypes.array,
  caseHeader: PropTypes.object,
  quickFilterContext: PropTypes.object,

  fetchingGridFilterMenus: PropTypes.bool.isRequired,
  gotInitialGridFilterMenus: PropTypes.bool.isRequired,
  fetchingStateList: PropTypes.bool.isRequired,
  stateList: PropTypes.array.isRequired,
  getStateList: PropTypes.func.isRequired,
  fetchingAllSurveyTypesList: PropTypes.bool.isRequired,
  allSurveyTypes: PropTypes.array.isRequired,
  getAllSurveyTypes: PropTypes.func.isRequired,
  getGridFilterMenus: PropTypes.func.isRequired,
  getAppraiserManagers: PropTypes.func.isRequired,

  getCaseLocationsCount: PropTypes.func.isRequired,
  appraisalCaseCount: PropTypes.number,
  insuranceCaseCount: PropTypes.number,

  updatingCaseHeader: PropTypes.bool,
  updateCaseHeader: PropTypes.func,
  getHistory: PropTypes.func,
  getCaseHeader: PropTypes.func.isRequired,

  updateHeader: PropTypes.func,
  clearHeader: PropTypes.func,
  clearHeaderDefinitions: PropTypes.func,
  getCustomerServiceAssignToUsers: PropTypes.func,
  isFetchingAssignToUsers: PropTypes.bool,
  assignToUsers: PropTypes.array,
  getUnderwriters: PropTypes.func,
  underwriters: PropTypes.array,
  fetchingUnderwriters: PropTypes.bool,
  displayBrokerCaseHeader: PropTypes.bool,
  fetchingBusOpsDirectors: PropTypes.bool,
  busOpsDirectors: PropTypes.array,
  getBusOpsDirectors: PropTypes.func,
  fetchingBusOpsManagers: PropTypes.bool,
  busOpsManagers: PropTypes.array,
  getBusOpsManagers: PropTypes.func,
  getMinimalAppraiserList: PropTypes.func,
  minimalAppraiserList: PropTypes.array,
  fetchingMinimalAppraiserList: PropTypes.bool,
  appraiserManagers: PropTypes.object,
  fetchingAppraiserManagers: PropTypes.bool,
  getAllCustomerActionsForUser: PropTypes.func,
  fetchingAllCustomerActionsForUser: PropTypes.bool,
  allCustomerActionsForUser: PropTypes.array,
  getValuationCoordinators: PropTypes.func,
  valuationCoordinators: PropTypes.array,
  fetchingValuationCoordinators: PropTypes.bool,
  getValuationDirectors: PropTypes.func,
  valuationDirectors: PropTypes.array,
  fetchingValuationDirectors: PropTypes.bool,
  isFetchingAllCounties: PropTypes.bool,
  allCounties: PropTypes.array,
  getAllCounties: PropTypes.func,
  makeToast: PropTypes.func,
  exportTypes: PropTypes.array,
  fetchingExportTypes: PropTypes.bool,
  getExportTypes: PropTypes.func,
  getAllFieldDevelopmentManagers: PropTypes.func,
  fetchingFieldDevelopmentManagers: PropTypes.bool,
  fieldDevelopmentManagers: PropTypes.array,
  getAllLenderLogisticsManagers: PropTypes.func,
  isFetchingLenderLogisticsManagers: PropTypes.bool,
  lenderLogisticsManagers: PropTypes.array,
  canAssignField: PropTypes.bool,
  canAssignQA: PropTypes.bool,
  canAssignIncidents: PropTypes.bool,
  canAddBulkAutoQA: PropTypes.bool,
  canEditQuicklists: PropTypes.bool,
  hasFormPhotoSplitView: PropTypes.bool,
  canOrder: PropTypes.bool,
  showCaseHeaderV2: PropTypes.bool,
  canViewAppraisers: PropTypes.bool,
  canViewEmployeeContactInfo: PropTypes.bool,
  canViewExports: PropTypes.bool,
  canViewFrProfile: PropTypes.bool,
  canShareQuicklists: PropTypes.bool,
  canShareQuicklistGroup: PropTypes.bool,
  getAllServiceRegions: PropTypes.func,
  serviceRegions: PropTypes.array,
  fieldOperationsManager: PropTypes.array,
  isFetchingFieldOperationsManagers: PropTypes.bool,
  getAllFieldOperationsManagers: PropTypes.func,
  currentQuicklistId: PropTypes.number,
  setCurrentQuicklistId: PropTypes.func,
  currentRowIndex: PropTypes.number,
  setCurrentQuicklistRowIndex: PropTypes.func,
  canBulkPutOnHold: PropTypes.bool,
  internetUserId: PropTypes.number,
  canManageFieldScheduling: PropTypes.bool,
  isFetchingCustomerExperienceManagers: PropTypes.bool,
  isFetchingCustomerExperienceDirectors: PropTypes.bool,
  getCustomerExperienceManagers: PropTypes.func,
  getCustomerExperienceDirectors: PropTypes.func,
  customerExperienceManagers: PropTypes.array,
  customerExperienceDirectors: PropTypes.array,
  hasQuickFilters: PropTypes.bool,
};

const UPDATE_APPRAISAL_ETA = "appraiserEta";
const UPDATE_LAST_NOTE = "lastNote";

export default StaticQuickLists;
